<template>
  <ag-modal-container
    title="Ajouter un ordre de fabrication"
    width="800px"
    @close="back"
  >
    <batch-form
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="'Ajouter'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import BatchForm from '../components/BatchForm'

export default {
  name: 'BatchCreateContainer',
  components: {
    AgModalContainer,
    BatchForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      partType: '',
      partNumber: '',
      quantity: null,
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.batch.post(this.value)
        this.showSuccessNotification('L\'ordre de fabrication a bien été créé')
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
